module.exports = __webpack_public_path__ + "img/emitHairstyleeditor03.f8aae6c4.png";